import { Text } from "@/elements"
import { UsersIcon } from "@/icons/outline"
import clsx from "clsx"
interface EmptyStateProps {
  title: string
  description: string
  children?: React.ReactNode
  borderless?: boolean
  Icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, borderless = false, children, Icon }) => {
  return (
    <div
      className={clsx(
        "col-span-full flex min-h-[200px] w-full flex-col items-center justify-center rounded-md px-5 py-10",
        !borderless && "border border-bg-3"
      )}>
      <div className="mb-6 flex size-12 shrink-0 items-center justify-center rounded-md border border-fg-4 bg-bg-1 drop-shadow-md">
        {Icon ? (
          <Icon height={22} width={22} className="flex flex-shrink-0 stroke-fg-2" />
        ) : (
          <UsersIcon className="stroke-fg-2" />
        )}
      </div>

      <Text variant="body1" className="mb-1 text-fg-1">
        {title}
      </Text>
      <Text variant="body3" className="text-center text-fg-3">
        {description}
      </Text>
      {children}
    </div>
  )
}
